import { ChangeEvent, FC, useState } from "react";
import { Button, Drawer, Flex, Input, LegacyForm, Typography } from "@payping/web-components";
import { useAppSelector, useAppTranslation } from "@/utils";
import { Close } from "@payping/icons";
import EditActionButtons from "@/components/mobile/settings/EditActionButtons";
import { ValidNationalId } from "@payping/utils/validation";
import { DashboardRoutes } from "@/router/constant";
import { isPersonalDisable } from "@/mobile/Settings/Personal/Edit/isPersonalDisable";
import { useHandleNavigationURL, useSaveToRedux } from "@/mobile/Settings/Personal/utils";
import { settingsPersonalAtom } from "../../state";
import { selectAtom } from "jotai/utils";
import { useAtom } from "jotai";

const mobileFormEditAtom = selectAtom(settingsPersonalAtom, (val) => val.mobileFormEdit);

const MobileEditPersonalNationalCode: FC = () => {
  const [isDrawerOpen, setIsDrawerOpen] = useState(true);
  const [form] = LegacyForm.useForm();
  const { t } = useAppTranslation();
  const [mobileFormEditState] = useAtom(mobileFormEditAtom);
  const nationalCodeApi = useAppSelector((state) => state.user.personalInfo?.nationalCode);

  const [nationalCode, setNationalCode] = useState<string | undefined>();

  // Custom Hooks
  const { handleNavigationURL } = useHandleNavigationURL();
  const { saveToRedux } = useSaveToRedux();

  return (
    <>
      <Drawer
        open={isDrawerOpen}
        title={`${t("edit")} / ${t("nationalCode")}`}
        size={"100%"}
        placement={"bottom"}
        closeIcon={false}
        extra={<Button type={"text"} icon={<Close width={14} height={14} />} onClick={handleNavigationURL} />}
      >
        <Flex vertical>
          <LegacyForm
            onFinish={() =>
              saveToRedux({
                nextUrlForMobileRegisterURL: DashboardRoutes.register.mEditPersonal.email.url,
                fieldName: "nationalCode",
                fieldValue: nationalCode,
                setIsDrawerOpen,
              })
            }
            form={form}
            initialValues={{ nationalCode: mobileFormEditState.nationalCode ?? nationalCodeApi }}
          >
            <LegacyForm.Item
              name="nationalCode"
              rules={[
                () => ({
                  validator(_, value): Promise<void> {
                    if (ValidNationalId(value)) {
                      return Promise.resolve();
                    }
                    return Promise.reject(new Error(t("profile.validBNationalCode")));
                  },
                }),
                { message: t("error.requiredForTaxCode", { name: t("nationalCode") }), required: true },
              ]}
            >
              <Input
                value={nationalCode}
                placeholder={t("mobileEditPersonal.enterField", { fieldName: t("common.nationalCode") })}
                onChange={(e: ChangeEvent<HTMLInputElement>) => setNationalCode(e.target.value)}
                disabled={isPersonalDisable()}
              />
            </LegacyForm.Item>
          </LegacyForm>

          <Typography.Text type={"secondary"}>
            {t("settings.personal.instructions.nationalIdAndBirthdate")}
          </Typography.Text>
        </Flex>
      </Drawer>
      <EditActionButtons onAccept={form.submit} />
    </>
  );
};
export default MobileEditPersonalNationalCode;
